import { Component } from 'react';
import { restClient } from 'libs/restClient';

// const fakeRealFcc = 'TLTACM8060';
// const fakeRealFcc = 'AZAZA';
const minLength = 3;
// const maxLength = 5;

export default class FccIdChecker extends Component {
  constructor(props) {
    super(props);

    this.state = { codeLength: minLength };
  }

  checkFccId = fccId => {
    return restClient
      .get(`https://apps.fcc.gov/OETLabServices/getFCCIDList?fccId=${fccId}`)
      .then(response => {
        if (response.data.fccidInfo) {
          return Promise.resolve(true);
        }
        return Promise.resolve(null);
      })
      .catch(err => {
        return err;
      });
  };

  submitFccSearchForm = (granteeCode, productCode) => {
    // const bodyFormData = new FormData();
    // bodyFormData.append('file', fileContent);
    // const url = `/requests/${requestId}/documents/${slot}?title=${title}`;
    // const payload = restClient
    //   .post(url, bodyFormData)
    //   .then(response => {
    //     callback();
    //     return response;
    //   })
    //   .catch(err => {
    //     callback();
    //     return err;
    //   });
  };

  sliceLeft = (str, length) => str.slice(0, length);
  sliceRight = (str, length) => str.slice(-length);

  componentDidMount() {
    // const code1 = this.sliceLeft(fakeRealFcc, minLength);
    // const code2 = this.sliceLeft(fakeRealFcc, maxLength);
    // this.checkFccId(code1);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/FccIdChecker.js